import StaticPages from "./StaticPages.page";

export default StaticPages;